
angular.module('trainerWebApp.resources').factory('SeriesCtrlResolver',
  ['$q', '$route', 'Auth', 'seriesTraineesResource', 'arrangeResource', 'CustomizeResource', 'CustomEmailResource', 'Validation', '$location', 'mtypes', 'errorHandler', 'usersResource', 'authView', function ($q, $route, Auth, seriesTraineesResource, arrangeResource, CustomizeResource, CustomEmailResource, Validation, $location, mtypes, errorHandler, usersResource, authView) {

    return function () {
      var deferred = $q.defer();

      var tabName = $route.current.params.tabName;
      var seriesId = $route.current.params.seriesId;

      var successCb = function (result) {
        Auth.getRolePromise().then(function() {
          if(seriesId) {
            if (angular.isArray(result) && angular.equals(result, [])) {
              deferred.reject("No series found by that id.");
            } else {
              deferred.resolve(result);
            }
          } else {
            deferred.resolve();
          }
        });
      };

      // we have to wrap resource into a promise because it returns just a regular object
      function wrapResource(resource, id) {
        var d = $q.defer();
        resource(id, function (result) {
          d.resolve(result);
        }, function (error) {
          // TODO: Better error checking
          if (error && error.data && error.data.error)
            d.reject(error.data.error.stack);
          else
            d.reject("Bad Series ID?");
        });
        return d.promise;
      }

      // TODO: Make this cleaner

      // let the controller handle the validate
      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      // Iverson Fix this
      if (!seriesId)
        successCb([]);

      // If redirecting to Flex than quit out before trying to hit gaviota-api for data.
      if(!seriesId && !tabName)
        return;

      if (!tabName) {
        if(!~mfConfig.features.indexOf(mtypes.featureEntry.series) && !authView.isActiveAdvancedtrial())
          arrangeResource.getSeriesPreviewInfo(successCb, errorHandler.defaultServerErrorHandler());
        else if (mfConfig.permissions == mtypes.userRole.administrator || mfConfig.permissions == mtypes.userRole.trainer)
          arrangeResource.getSeriesInfo(seriesId, successCb, errorHandler.defaultServerErrorHandler());
        else if (!!~mfConfig.userPrivileges.indexOf(mtypes.userPrivilege.canInviteUsers))
          CustomizeResource.getCourseSettings(seriesId, successCb, errorHandler.defaultServerErrorHandler());
        else
          seriesTraineesResource.traineesSetup(seriesId, successCb, errorHandler.defaultServerErrorHandler());
      }

      if (tabName == 'manage') {
        arrangeResource.getSeriesInfo(seriesId, successCb, errorHandler.defaultServerErrorHandler());
      } else if (tabName == 'trainees') {
        seriesTraineesResource.traineesSetup(seriesId, successCb, errorHandler.defaultServerErrorHandler());
      } else if (tabName == 'addExistingTrainees') {
        seriesTraineesResource.inviteSetup(seriesId, successCb, errorHandler.defaultServerErrorHandler());
      } else if (tabName == 'addYammerUsers') {
        successCb({});
      } else if (tabName == 'customize') {
        CustomizeResource.getCourseSettings(seriesId, successCb, errorHandler.defaultServerErrorHandler());
      } else if (tabName == 'emails') {
        CustomEmailResource.getSeriesEmail(seriesId, successCb, errorHandler.defaultServerErrorHandler());
      } else if (tabName == 'addNewUser') {
        usersResource.getAddUserSetupForCourseType(successCb, errorHandler.defaultServerErrorHandler());
      } else if (tabName == 'importXls') {
        successCb(['passThrough']);
      }

      return deferred.promise;
    };
  }]
);
